import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        ticket_statuses: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {}
            }
        },
        has_errors: false,
        dialogVisible: false,
        loading: false
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        ticket_statuses: state => state.ticket_statuses,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setTicketStatuses(state, data) {
            state.ticket_statuses = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {}
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getTicketStatuses({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getTicketStatuses(filters);
                commit('setTicketStatuses', response.data);
                commit('deactivateLoading', 'gender/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async createTicketStatuses({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createTicketStatuses(data);
                ElMessage.success('ticket Status created successfully.');
                commit('setDialogVisible', false)
                dispatch('getTicketStatuses', {
                    paginate: true
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating ticket Status.');
            }
        },
        async editTicketStatus({dispatch, commit}, data) {
            try {
                await api.editTicketStatus(data);
                dispatch('getTicketStatuses', {
                    paginate: true
                });
                ElMessage.success('ticket Status updated successfully.');
                commit('setDialogVisible', false)
            } catch (e) {
                ElMessage.error('Error Updating ticket Status');
            }
        },

        async deleteTicketStatus({dispatch}, data) {
            try {
                await api.deleteTicketStatus(data);
                ElMessage.success('ticket Status removed successfully.');
                dispatch('getTicketStatuses', {
                    paginate: true
                })
            } catch (e) {
                ElMessage.error('Error removing ticket Status');
            }
        },

    }
}
